import { UIService } from './ui-service.js';
import { ActionPointRunner } from '../../providers/action-point/action-point-runner.js';

/**
 * 工作台 UI 管理器基类
 *
 * @public
 */
class SchematicUIService extends UIService {
    constructor() {
        super(...arguments);
        this.pathMap = new Map();
        this.reversedPathMap = new Map();
    }
    /**
     * 更新配置表
     *
     */
    setSchema(schema) {
        this.schema = schema;
        this.updateState();
    }
    /**
     * 获取配置表
     */
    getSchema() {
        return this.schema;
    }
    getPathByConfig(config) {
        var _a;
        return (_a = this.pathMap.get(config)) !== null && _a !== void 0 ? _a : [];
    }
    getConfigByPath(path) {
        return Array.isArray(path) ? this.reversedPathMap.get(path.join('/')) : this.reversedPathMap.get(path);
    }
    /**
     * 记录schema路径到actionInfo到action
     * @param config - 处理过的menuConfig
     * @param pathMap - config路径查询
     * @param prefix - 前缀path
     */
    setPathToActionInfoInConfig(config, prefix) {
        const path = [];
        if (prefix) {
            path.push(...prefix);
        }
        path.push(config.name);
        this.pathMap.set(config, path);
        this.reversedPathMap.set(path.join('/'), config);
        Object.entries(config).forEach(([key, item]) => {
            if (item instanceof ActionPointRunner) {
                const runner = item.merge([]);
                const activePath = this.getPathByConfig(config);
                runner.point = Object.assign(Object.assign({}, item.point), { path: activePath, name: config.name });
                config[key] = runner;
            }
        });
    }
    getMergedConfig(key) {
        let tempConfigUsed = false;
        if (!this.hasConfig(key) && Object.keys(this.schema).includes(key)) {
            this.configs.set(key, { name: key });
            tempConfigUsed = true;
        }
        const config = super.getMergedConfig(key);
        if (tempConfigUsed) {
            this.configs.remove(key);
        }
        return config;
    }
    getAllKeys() {
        return [...Object.keys(this.schema), ...this.configs.getAllKeys()];
    }
    /**
     * 更新配置表并刷新
     */
    mergeSchema(schema) {
        this.mergeSchemaWithoutUpdate(schema);
        this.updateState();
    }
    onUpdate() {
        this.pathMap.clear();
        this.reversedPathMap.clear();
    }
    forceUpdateWithStore(store, key) {
        const data = store.getValue(key);
        if (data === null) {
            this.onUpdate();
            return;
        }
        if (Array.isArray(data)) {
            store.get(key).next(data.slice());
            return;
        }
        if (typeof data === 'object') {
            store.get(key).next(Object.assign({}, data));
            return;
        }
        store.get(key).next(data);
    }
}

export { SchematicUIService, SchematicUIService as default };
//# sourceMappingURL=schematic-ui-service.js.map
